// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W9Rt3","colMin":"styles_colMin__2gZEU"};